import store from '@/store/store';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import genererLigneCommande from '@/services/devisCommandes/genererLigneCommande';
import miseAJourArticle from '@/services/devisCommandes/miseAJourArticle';
import * as devisConf from '@/configuration/devisConf';
import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import { get } from '@/api/produit/produitReseauNumerique';
import { get as getProduitAssocie } from '@/api/produit/index';
import { get as getProduitLocation } from '@/api/produit/produitLocation';
import calculDateFin from '@/services/general/calculDateFin';
import returnLiaisonTarif from '@/services/catalogue/getLiaisonTarifADate';
import * as produitConf from '@/configuration/catalogue/produitConf';
import genererLiaisonTarifFromProduitAssocie from '@/services/devisCommandes/genererLiaisonTarifFromProduitAssocie';
import updateQuantiteLiaisonTarif from '@/services/devisCommandes/updateQuantiteLiaisonTarif';
import * as saturationConvertisseur from '@/services/devisCommandes/numerique/saturationConvertisseur';
import creationRegroupementPersonnalise from '@/services/devisCommandes/regroupementPersonnalise/creationRegroupementPersonnalise';
import { getProduitLocForImportNum } from '@/services/excel/produitReseauNumerique/getProduitsLocForExportImportNum';
import calculArrondi from '@/services/calcul/calculArrondi';
import calculTlpe from '@/services/dcf/tlpe/calculTlpe';
import setFournisseurIfNotRegie
  from '@/services/devisCommandes/bonAFacturer/setFournisseurIfNotRegie';
import setAFacturerOfLigne from '@/services/devisCommandes/bonAFacturer/setAFacturerOfLigne';
import genererCommentaireVenteForLigne from '@/services/devisCommandes/ajoutProduit/genererCommentaireVente';
import generationToutesLignesCommandes from './genererToutesLignesCommande';

async function generationLigneCommandeRegroupement(
  produitReseau, produitsAssocies, periode, dcf, tauxTva,
) {
  const nouvelleLigneCommande = genererLigneCommande();
  miseAJourArticle(nouvelleLigneCommande);
  nouvelleLigneCommande.title = produitsAssocies && produitsAssocies.libelle
    ? produitReseau.reference + ' - ' + produitsAssocies.libelle : produitReseau.reference;
  nouvelleLigneCommande.produitId = produitReseau.id;
  nouvelleLigneCommande.typeProduit = produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE;
  nouvelleLigneCommande.produit = produitReseau;
  nouvelleLigneCommande.tauxTva = 0;
  if (periode && periode.dateDebut) {
    nouvelleLigneCommande.dateDebut = new Date(periode.dateDebut);
    nouvelleLigneCommande.dateFin = new Date(periode.dateFin);
  } else {
    nouvelleLigneCommande.dateDebut = dcf && dcf.datePremiereAffichage || new Date();
    const dateFin = calculDateFin(
      nouvelleLigneCommande.dateDebut, produitsAssocies.quantite, produitsAssocies.uniteVente,
    );
    if (dateFin) nouvelleLigneCommande.dateFin = dateFin;
    else {
      nouvelleLigneCommande.dateFin = calculDateFin(
        nouvelleLigneCommande.dateDebut, 1, devisConf.ANNEE,
      );
    }
  }
  nouvelleLigneCommande.libelle = produitReseau.libelle;
  nouvelleLigneCommande.masqueLigne = false;
  nouvelleLigneCommande.type = devisConf.REGROUPEMENT;

  if (produitsAssocies && produitsAssocies.produitEnfant) {
    nouvelleLigneCommande.lignesCommande = await generationToutesLignesCommandes(
      produitsAssocies, tauxTva,
    );
  } else nouvelleLigneCommande.lignesCommande = [];

  // AJOUT D INFORMATION SUPPLEMENTAIRE EN FONCTION DE LA SOCIETE (REGIE, MANDATIARE ...)
  setFournisseurIfNotRegie(produitReseau, nouvelleLigneCommande);
  setAFacturerOfLigne(nouvelleLigneCommande, dcf);

  return nouvelleLigneCommande;
}

export async function ajoutLignesCommandeProduitReseauNumeriqueViaObject(
  devisCommande, produitReseau, produitAssocie, ordre, periode, tauxTva,
) {
  let liaisonTarif = [];
  if (produitAssocie !== null) {
    if (periode && periode.dateDebut) {
      const liaisonTarifTempo = returnLiaisonTarif(
        produitReseau, produitAssocie.id, new Date(periode.dateDebut),
      );
      liaisonTarif = cloneDeep(liaisonTarifTempo);
      // Voir tarifDansLePanier
      // La quantité de la liaison tarif est remplacée
      // dans certains cas
      updateQuantiteLiaisonTarif(liaisonTarif, periode.dateDebut, periode.dateFin);
      if (liaisonTarif && liaisonTarif.quantiteAjustee) {
        liaisonTarif.quantite = liaisonTarif.quantiteAjustee;
      }
    } else {
      const liaisonTarifTempo = returnLiaisonTarif(produitReseau, produitAssocie.id,
        new Date());
      liaisonTarif = cloneDeep(liaisonTarifTempo);
    }

    // cas où le produit de location n'est pas mis par défaut
    if (!liaisonTarif) {
      const liaisonTarifTempo = genererLiaisonTarifFromProduitAssocie(
        produitAssocie, periode,
      );
      liaisonTarif = cloneDeep(liaisonTarifTempo);
    }
  }
  const nouvelleLignesCommande = await generationLigneCommandeRegroupement(
    produitReseau, liaisonTarif, periode, devisCommande, tauxTva,
  );
  if (periode && periode.saturation) {
    nouvelleLignesCommande.quantiteDispo = saturationConvertisseur
      .toQuantiteDispo(periode.saturation);
  }
  ajoutOrdre(nouvelleLignesCommande, devisCommande.lignesCommande.length, ordre);
  genererCommentaireVenteForLigne(produitReseau, nouvelleLignesCommande);
  try {
    await store.dispatch('parametres/loadParametresInterne', [PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key]);
    const parametresInterne = store.getters['parametres/parametresInterne'];
    const surPeriode = parametresInterne(PARAMETRES_INTERNE_KEYS.periodeTotalCalculTlpeAuto.key);
    await calculTlpe(nouvelleLignesCommande, devisCommande.type === devisConf.TYPE_FACTURE,
      surPeriode);
  } catch (e) {
    nouvelleLignesCommande.lignesCommande.forEach((el) => {
      if (el.typeProduit === produitConf.CATEGORIE_DIVERS && el.calculAutomatiqueTlpe
        && el.produit.produitDivers.tlpe) {
        el.prixUnitaire = 0;
      }
    });
  }
  return [nouvelleLignesCommande];
}

export async function ajoutLignesCommandeProduitReseauNumeriqueViaId(
  devisCommande, idProduit, idProduitAssocie, ordre, tauxTva,
) {
  let saturation = null;
  const produitReseau = (await get(idProduit)).data.result;
  let produitAssocie = null;
  if (idProduitAssocie) {
    produitAssocie = (await getProduitAssocie(idProduitAssocie))
      .data.result;
    if (produitAssocie.supportCommercial.categorieVente === produitConf.CATEGORIE_LOCATION) {
      const produitLoc = (await getProduitLocation(produitAssocie.id)).data.result;
      saturation = produitLoc.produitLocation.saturation;
    }
  }
  return ajoutLignesCommandeProduitReseauNumeriqueViaObject(
    devisCommande, produitReseau, produitAssocie, ordre,
    { saturation: saturation }, tauxTva,
  );
}

export async function ajoutLignesCommandeProduitReseauNumfromXlsx(
  devisCommande, produits, i18n, tauxTva,
) {
  const produitLoc = await getProduitLocForImportNum();
  produitLoc.produitLocation.quantite = 1;
  produitLoc.produitLocation.unite = devisConf.UNITE;
  const promises = [];
  produits.forEach((produit) => {
    promises.push((get(produit.id)));
  });
  const periode = { dateDebut: moment(), dateFin: moment() };
  const produitsReseauNum = await Promise.all(promises);
  const lignesCommandePromise = [];
  for (let i = 0; i < produitsReseauNum.length; i += 1) {
    const produitReseau = produitsReseauNum[i].data.result;
    const objectFromXlsx = produits.find((produit) => {
      return produit.id === produitReseau.id;
    });
    if (!produitReseau || !objectFromXlsx) return;
    produitLoc.produitLocation.prixUnitaire = calculArrondi(objectFromXlsx.tarifAccess, 2);
    const liaisonTarifTempo = genererLiaisonTarifFromProduitAssocie(produitLoc, periode);
    lignesCommandePromise.push(generationLigneCommandeRegroupement(
      produitReseau, liaisonTarifTempo, periode, null, tauxTva,
    ));
  }
  const lignesCommandes = [];
  const lignes = await Promise.all(lignesCommandePromise);
  for (let i = 0; i < lignes.length; i += 1) {
    lignes[i].quantiteDispo = saturationConvertisseur.toQuantiteDispo(2);
    ajoutOrdre(lignes[i], null, i * 100);
    lignesCommandes.push(lignes[i]);
  }
  creationRegroupementPersonnalise(lignesCommandes, lignesCommandes, i18n);
  devisCommande.lignesCommande = lignesCommandes;
}
